import React from "react";

export interface Bar {
  value: number;
  color?: string;
  className?: string;
}

interface SimpleBarChartProps {
  bars: Bar[];
  defaultColor?: string;
  maxHeight?: number;
  gap?: number;
  maxValue?: number;
}

const SimpleBarChart: React.FC<SimpleBarChartProps> = ({
  bars,
  defaultColor = "var(--sapphire-30)",
  maxHeight = 80,
  gap = 8,
  maxValue: propMaxValue,
}) => {
  const maxValue = propMaxValue || Math.max(...bars.map((bar) => bar.value));

  const getBarHeight = (value: number) => {
    if (maxValue === 0) return 0;
    return (value / maxValue) * maxHeight;
  };

  return (
    <div
      className="flex items-end justify-center"
      style={{ gap: `${gap}px`, height: `${maxHeight}px` }}
    >
      {bars.map((bar, index) => {
        const height = getBarHeight(bar.value);
        const barColor = bar.color || defaultColor;

        return (
          <div
            key={index}
            className={`flex-1 rounded-t transition-all ${bar.className || ""}`}
            style={{
              height: `${height}px`,
              backgroundColor: barColor,
              minWidth: "20px",
            }}
          />
        );
      })}
    </div>
  );
};

export default SimpleBarChart;
